import { extractProductIdFromLdJson } from '@core/helpers/extractProductIdFromLdJson'

/**
 * If params.skus === {{product.id}} then use
 * window._fwn.productData.product_ext_id.
 * Otherwise, use params.skus.
 * This is supported from the BE with every integration,
 * so we can safely use it.
 * @param skus
 * @returns
 */
export function updateSkus(skus: string | undefined): string | undefined {
  if (skus === '{{product.id}}') {
    const productExtId = window._fwn?.productData?.product_ext_id
    if (productExtId) {
      return productExtId
    }

    const ldJsonResult = extractProductIdFromLdJson()
    return ldJsonResult.value ?? undefined
  }

  return skus
}
